<div class="emd-container">
    <div class="emd-container__header eu-height_auto">
        <div class="emd-status-bar _color_success"></div>
        <h2 class="emd-text _size_subpage _color_default">
            Histórico
        </h2>
    </div>

    <div class="emd-container__content">

        <div class="eu-basis_12 eu-basis_10_md eu-offset_1_md" *ngIf='showGetHistoryTranslationLoader'>
            <div class="eu-basis_12 eu-basis_2_md eu-offset_5_md emd-text _align_center _type_hint _color_primary">
                <div class="spinner-border"></div>
            </div>
        </div>

        <h3><strong class="emd-text _color_primary">Total de registros de histórico:
            </strong>{{translatedAmountOfHistoryEvents}}
        </h3>
        <div class="emd-table-responsive" *ngIf='!showGetHistoryTranslationLoader'>
            <table class="emd-table">
                <thead>
                    <tr>
                        <th>Tipo de evento</th>
                        <th>Data e hora</th>
                        <th>Realizado por</th>
                        <th>Alteração</th>
                    </tr>
                </thead>
                <tbody *ngFor='let historyEvent of historiesOfActualPage'>
                    <tr>
                        <td class="emd-text _color_default" data-label='Tipo de evento'>{{historyEvent.event_name}}</td>
                        <td class="emd-text _color_default" data-label='Data e hora'>
                            {{historyEvent.created_at_formatted_date}}</td>
                        <td class="emd-text _color_default" data-label='Realizado por'>
                            {{historyEvent.done_by_account_user_email}}</td>
                        <td class="emd-text _color_default" data-label='Alteração'>
                            {{historyEvent.change_log}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="emd-container__footer" *ngIf='translatedAmountOfHistoryEvents > 5'>
            <div class="emd-pagination">
                <span class="emd-text _color_default">Página {{actualPage}} de
                    {{historyEventsTotalOfPages}}</span>
                <button class="emd-btn _color_primary _type_text" (click)='historyPreviousPage()' [disabled]='actualPage == 1'>Anterior</button>
                <button class="emd-btn _color_primary _type_text" (click)='historyNextPage()' [disabled]='actualPage == historyEventsTotalOfPages'>Próxima</button>
            </div>
        </div>

        <!-- Botão de fechar a direita do box -->
        <div class="emd-container__aside">
            <button class="emd-btn emd-btn-ghost" (click)='closeConfirmModal()'>
                <i class="fa fa-times" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</div>